@if (visible && (dialogProperties$ | async); as dialogProperties) {
  <bd-dialog
    data-id="advanced-filter-dialog"
    [visible]="visible"
    (dismiss)="cancel()"
    [dialogProperties]="dialogProperties"
    (visibleChange)="setVisibility($event)"
    *transloco="let t; scope: 'featureSearch'"
  >
    <div class="bd-advanced-filter-dialog">
      <p-accordion
        [multiple]="true"
        [value]="['0']"
        class="bd-dialog-accordion bd-accordion-expand-fix"
        expandIcon="ui-down"
        collapseIcon="ui-up"
      >
        <p-accordion-panel value="0" data-id="category-filter">
          <p-accordion-header>{{
            t('featureSearch.category')
          }}</p-accordion-header>
          <p-accordion-content>
            <bd-advanced-filter-options
              [filterOptions]="(filteredScopeFilterOptions$ | async) ?? []"
              [selectedFilterOptions]="selectedAdvancedFilter.scopeFilters"
              (submitSelectedFilters)="updateScopeFilters($event)"
            >
            </bd-advanced-filter-options
          ></p-accordion-content>
        </p-accordion-panel>
        <p-divider class="bd-light-divider"></p-divider>
        <p-accordion-panel value="1" data-id="element-type-filter">
          <p-accordion-header>{{
            t('featureSearch.elementType')
          }}</p-accordion-header>
          <p-accordion-content>
            <div class="flex flex-col gap-6 mb-6">
              <div
                class="bd-section-description"
                data-id="element-type-description"
              >
                {{ t('featureSearch.elementTypeDescription') }}
              </div>
            </div>
            <bd-advanced-filter-options
              [filterOptions]="elementTypeFilterOptions"
              [selectedFilterOptions]="
                selectedAdvancedFilter.elementTypeFilters
              "
              [isHorizontal]="true"
              (submitSelectedFilters)="updateElementTypeFilters($event)"
            >
            </bd-advanced-filter-options>
          </p-accordion-content>
        </p-accordion-panel>
        <p-divider class="bd-light-divider"></p-divider>
        <p-accordion-panel value="2" data-id="attribute-filter">
          <p-accordion-header>{{
            t('featureSearch.attributeFilter.tab')
          }}</p-accordion-header>
          <p-accordion-content>
            <div class="flex flex-col gap-6">
              <div
                data-id="attribute-description"
                class="bd-section-description"
              >
                {{ t('featureSearch.attributeFilter.description') }}
              </div>
              <ng-template #defaultFilterRow>
                <bd-advanced-filter-attribute
                  #defaultAttributeFilter
                  data-id="default-attribute-filter"
                  (submitAttributeFilter)="onSubmitAttributeFilter($event)"
                  (removeAttributeFilter)="removeAttributeFilter($event)"
                  [filterValue]="clonedDefaultAttributeFilterValue"
                ></bd-advanced-filter-attribute>
              </ng-template>
              @for (
                selectedFilter of selectedAdvancedFilter.attributeFilters;
                track selectedFilter.id;
                let last = $last
              ) {
                <bd-advanced-filter-attribute
                  #selectedAttributeFilter
                  (submitAttributeFilter)="onSubmitAttributeFilter($event)"
                  (removeAttributeFilter)="removeAttributeFilter($event)"
                  [filterValue]="selectedFilter"
                ></bd-advanced-filter-attribute>
                @if (last) {
                  <ng-container
                    *ngTemplateOutlet="defaultFilterRow"
                  ></ng-container>
                }
              } @empty {
                <ng-container
                  *ngTemplateOutlet="defaultFilterRow"
                ></ng-container>
              }</div
          ></p-accordion-content>
        </p-accordion-panel>
        <p-divider class="bd-light-divider"></p-divider>
        <p-accordion-panel value="3" data-id="relationship-filter">
          <p-accordion-header>{{
            t('featureSearch.relationshipFilter.tab')
          }}</p-accordion-header>
          <p-accordion-content>
            <div class="flex flex-col gap-6">
              <div
                data-id="relationship-description"
                class="bd-section-description"
              >
                {{ t('featureSearch.relationshipFilter.description') }}
              </div>
              @for (
                selectedFilter of selectedAdvancedFilter.relationFilters;
                track selectedFilter.id;
                let last = $last
              ) {
                <bd-advanced-filter-relationship
                  #selectedRelationFilter
                  (submitRelationFilter)="onSubmitRelationFilter($event)"
                  (removeRelationFilter)="removeRelationFilter($event)"
                  [initialFilterValue]="selectedFilter"
                ></bd-advanced-filter-relationship>
                @if (last) {
                  <bd-advanced-filter-relationship
                    #defaultRelationFilter
                    data-id="default-relationship-filter"
                    (submitRelationFilter)="onSubmitRelationFilter($event)"
                    (removeRelationFilter)="removeRelationFilter($event)"
                    [initialFilterValue]="clonedDefaultRelationFilterValue"
                  ></bd-advanced-filter-relationship>
                }
              }
              @if (selectedAdvancedFilter.relationFilters.length === 0) {
                <bd-advanced-filter-relationship
                  data-id="default-relationship-filter"
                  (submitRelationFilter)="onSubmitRelationFilter($event)"
                  (removeRelationFilter)="removeRelationFilter($event)"
                ></bd-advanced-filter-relationship>
              }</div
          ></p-accordion-content>
        </p-accordion-panel>
        <p-divider class="bd-light-divider"></p-divider>
        <p-accordion-panel value="4" data-id="people-filter">
          <p-accordion-header>{{
            t('featureSearch.peopleFilter.tab')
          }}</p-accordion-header>
          <p-accordion-content>
            <div class="flex flex-col gap-6">
              <bd-advanced-filter-people
                [selectedFilter]="selectedAdvancedFilter.systemAttributesFilter"
                (filterChange)="updateSystemAttributesFilter($event)"
                [users]="users"
                [usersLoading]="usersLoading"
                (searchUsers)="searchUsers.emit($event)"
                [authenticatedUser]="authenticatedUser"
              ></bd-advanced-filter-people></div
          ></p-accordion-content>
        </p-accordion-panel>
      </p-accordion>
    </div>
    <div class="flex justify-between w-full" footer>
      @if (
        selectedAdvancedFilter.elementTypeFilters.length > 0 ||
        selectedAdvancedFilter.scopeFilters.length > 0 ||
        selectedAdvancedFilter.attributeFilters.length > 0 ||
        selectedAdvancedFilter.systemAttributesFilter
      ) {
        <p-button
          data-id="clear-filters"
          [text]="true"
          [label]="t('featureSearch.clearAll')"
          (onClick)="clearFilters()"
        ></p-button>
      }
      <div class="flex gap-x-4 justify-end grow">
        <p-button
          data-id="cancel"
          [outlined]="true"
          [label]="t('featureSearch.cancel')"
          (onClick)="cancel()"
        ></p-button>
        <p-button
          data-id="submit-filters"
          [label]="
            t('featureSearch.viewCount', {
              totalSearchResultsCount: totalSearchResultsCount,
            })
          "
          (onClick)="submitFilters()"
          [loading]="searchResultsCountLoading"
        ></p-button>
      </div>
    </div>
  </bd-dialog>
}
